<i18n>
{
  "ja":{
    "fromOrigin": "中心部から <b>{distance}km</b>",
    "seeDetails": "詳細を見る",
    "contact-warehouse": "<span>この倉庫に</span>問い合わせ"
  },
  "en":{
    "fromOrigin": "<b>{distance}km</b> from origin",
    "seeDetails": "Show details",
    "contact-warehouse": "Contact<span> this warehouse</span>"
  }
}
</i18n>

<template>
  <div
    class="w-full warehouse-item bg-white mx-0 my-2 md:m-0 rounded-md shadow-md md:rounded-none md:shadow-none md:border-gray-200"
    :class="{ 'selected': selected, 'md:border-t': index > 0 }"
  >
    <div class="flex flex-row items-between">
      <div
        :data-background="getPhotoUrl(warehouse.photos)"
        :style="{'background-image': 'url(/img/WareX-chicklet.png)'}"
        class="photo flex-none swiper-lazy rounded-lg bg-cover bg-center bg-gray-200 relative"
      >
        <div class="swiper-lazy-preloader" />
      </div>
      <div class="pl-2 flex-grow font-bold text-xs">
        <div class="flex justify-between">
          <div>
            <div v-if="warehouse.lat === 0 && warehouse.lng === 0">-</div>
            <div
              v-else
              class="distance rounded-md inline-block font-normal whitespace-no-wrap"
              v-html="$t('fromOrigin', {distance: warehouse.distance != null ? warehouse.distance.toFixed(1) : '-'})"
            />
            <div class="mt-2 md:mt-1 text-base">
              <nuxt-link
                :to="{ path: localePath(`/warehouses/${warehouse.display_number}`), query: {...$route.query, area: $route.params.area }}"
                class="text-secondary leading-none border-b border-secondary inline-block"
              >
                {{ warehouse.region_name }}{{ warehouse.muni_name }}
              </nuxt-link>
            </div>
          </div>
          <freespace-info v-if="showFreeSpace" :free-spaces="freeSpaces"/>
        </div>
        <div class="warehouse-info mt-2 flex text-xs">
          <div class="warehouse-type" :class="warehouse.private ? 'private' : 'licensed'">
            <a
              href="https://warex.ai/faq/?category=warehouse-type"
              target="_blank"
              class="flex items-center whitespace-no-wrap"
            >
              <span class="text-xs">{{ warehouse.private ? $t('privateWarehouse') : $t('licensedWarehouse') }}</span>
              <i class="material-icons text-xs">help</i>
            </a>
          </div>
          <div class="temperature badge text-xs" :class="temperature">{{ $t(`warehouse.${temperature}`) }}</div>
          <div v-if="supportedCargo.length > 0" class="supported-cargo flex items-center">
            <div v-for="item in supportedCargo" :key="item" class="badge text-xs">
              {{ item }}
            </div>
            <div v-if="hasMoreSupportedCargo" class="badge px-2 font-bold">...</div>
          </div>
        </div>
      </div>
    </div>
    <div class="md:flex md:justify-end md:mt-3 md:mr-3">
      <button
        class="contact-link h-6 md:h-8 mt-2 mr-2 md:mt-0 md:-mr-3 px-2 md:px-3"
        @click="openInquiry(warehouse)"
      >
        <span>
          <span class="contact-text" v-html="$t('contact-warehouse')" />
        </span>
      </button>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.warehouse-type
  @apply border rounded mr-2 px-1 flex items-center
  &.licensed
    @apply border-warehouse-light-licensed bg-warehouse-light-licensed text-warehouse-licensed
  &.private
    @apply border-warehouse-light-private bg-warehouse-light-private text-warehouse-private

</style>

<script>
import { getPhotoUrl } from '@/components/utils/warehouse';
import freespaceInfo from '@/components/warehouses/search/freespaceInfo';
const MAX_TEXT_LENGTH = 9;

export default {
  components: { freespaceInfo },
  props: {
    warehouse: { type: Object, required: true },
    selected: { type: Boolean, required: true },
    index: { type: Number, required: true },
    isMobile: { type: Boolean, required: true }
  },
  computed: {
    temperature() {
      return this.warehouse.temperature_control;
    },
    supportedCargo () {
      // return item if the translated texts are less than 8 characters long
      if (this.isMobile) {
        this.warehouse.supported_cargo.slice(0, 1);
      }
      else {
        let items = [];
        let charCount = 0;
        this.warehouse.supported_cargo.forEach(item => {
          const translatedText = this.$t(`cargoType.${item}`);
          const textLength = charCount + translatedText.length;
          if (textLength <= MAX_TEXT_LENGTH) {
            items.push(translatedText);
            charCount = textLength + 1;
          }
        });
        return items;
      }
      return this.warehouse.supported_cargo.slice(0, 2);
    },
    hasMoreSupportedCargo() {
      const count = this.warehouse.supported_cargo.length;
      return this.isMobile ? count > 1 : count > this.supportedCargo.length;
    },
    showFreeSpace () {
      return !this.isMobile && this.warehouse.free_spaces.length > 0;
    },
    freeSpaces () {
      return this.warehouse.free_spaces;
    }
  },
  methods: {
    getPhotoUrl,
    stripLeadingZero(time) {
      const [hour, min] = time.split(':');
      return `${parseInt(hour, 10)}:${min}`;
    },
    async openInquiry (warehouse) {
      this.$router.push({
        path: this.localePath('/inquiry/'),
        query: { warehouse_code: warehouse.display_number }
      });
    }
  }
};
</script>
